import { Styles } from '@types'
import { Select, Input, Tag } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import { ExpenditureType } from 'gadjet-v2-types/dist/type'
import { expenditureType } from 'gadjet-v2-types/dist/type/label'
import { ExpenditureSearch } from 'gadjet-v2-types/dist/type/search'
import { RangeValue } from 'rc-picker/lib/interface'
import { useMemo } from 'react'

import LocalDatePicker from '@components/atoms/LocalDatePicker'
import SearchBox from '@components/molecules/SearchBox'
import SearchItem from '@components/molecules/SearchItem'

const options: { types: ExpenditureType[] } = {
  types: ['card', 'transfer', 'cash', 'commission'],
}

type Props = {
  search: ExpenditureSearch
  onChangeSearch: (search: Partial<ExpenditureSearch>) => void
  onSearch: () => void
}

export default function BranchExpenditureSearchBox({ search, onChangeSearch, onSearch }: Props): JSX.Element {
  const onChangeQuery = (e: React.ChangeEvent<HTMLInputElement>) => onChangeSearch({ query: e.target.value })
  const onChangeExpenditureType = (_expenditureTypes: ExpenditureType[]) =>
    onChangeSearch({ expenditureTypes: _expenditureTypes })

  const onChangeDateRange = (_value: RangeValue<Dayjs>) => {
    const start = _value?.[0]?.format('YYYY-MM-DD') || search.date[0]
    const end = _value?.[1]?.format('YYYY-MM-DD') || search.date[1]
    onChangeSearch({ date: [start, end] })
  }

  const rangeValue = useMemo((): [Dayjs, Dayjs] => {
    const [start, end] = search.date
    return [dayjs(start), dayjs(end)]
  }, [search])

  return (
    <SearchBox onSearch={onSearch}>
      <SearchItem label="날짜" span={6}>
        <LocalDatePicker.RangePicker
          size="large"
          style={styles.datePicker}
          value={rangeValue}
          onChange={onChangeDateRange}
        />
      </SearchItem>
      <SearchItem label="타입" span={9}>
        <Select
          mode="multiple"
          onChange={onChangeExpenditureType}
          size="large"
          value={search.expenditureTypes}
          style={styles.select}
          tagRender={({ label }) => <Tag>{label}</Tag>}
        >
          {options.types.map((t) => (
            <Select.Option key={t} value={t}>
              {expenditureType[t]}
            </Select.Option>
          ))}
        </Select>
      </SearchItem>
      <SearchItem label="메모 검색" span={6}>
        <Input size="large" placeholder="검색어를 입력하세요." value={search.query} onChange={onChangeQuery} />
      </SearchItem>
    </SearchBox>
  )
}

const styles: Styles = {
  datePicker: { width: '100%' },
  select: { width: '100%' },
}
